export default "<div ng-repeat=\"message in vm.messages\" ng-message=\"{{message.type}}\">\n  {{vm.getMessageKey(message) | translate}}\n</div>\n";